<template>
	<v-card outlined :class="[$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-3']">
		<v-card-title>
			{{ `Orden de compra: ${purchaceorder.id}` }}
		</v-card-title>

		<v-card-subtitle>
			{{
				`${purchaceorder.articles_with_count} productos agregadas a esta orden de compra.`
			}}
		</v-card-subtitle>

		<v-card-text>
			<v-row class="pt-0">
				<v-col
					cols="12"
					md="5"
					class="d-flex flex-column justify-space-around pt-0 black--text"
				>
					<div>
						<span class="font-weight-bold">
							Metodo de envío:
						</span>

						<template v-if="purchaceorder.shipping_method">
							{{ purchaceorder.shipping_method.name }}
						</template>
					</div>

					<div>
						<span class="font-weight-bold">
							Creado:
						</span>
						<v-tooltip right>
							<template
								v-slot:activator="{
									on,
									attrs,
								}"
							>
								<span v-bind="attrs" v-on="on">
									{{ purchaceorder.created_at_for_humans }}
								</span>
							</template>
							<span v-if="purchaceorder.status">
								{{ purchaceorder.created_at }}
							</span>
						</v-tooltip>
					</div>

					<div>
						<span class="font-weight-bold">
							Estado:
						</span>

						<template v-if="purchaceorder.status">
							{{ purchaceorder.status.name }}
						</template>
					</div>
				</v-col>

				<v-col
					cols="12"
					md="5"
					class="d-flex align-start pt-0 black--text"
				>
					<div v-if="purchaceorder.note">
						<span class="font-weight-bold">
							Nota:
						</span>
						{{ purchaceorder.note }}
					</div>
				</v-col>

				<v-col cols="12" md="2" class="d-flex justify-end align-center">
					<router-link
						tag="div"
						style="width: 100%;"
						class="d-flex justify-end"
						:to="{
							name: 'PurchaceShow',
							params: {
								id: purchaceorder.id,
							},
						}"
					>
						<v-btn
							:block="$vuetify.breakpoint.smAndDown"
							outlined
							color="primary"
						>
							Ver
						</v-btn>
					</router-link>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: "Item",

	props: ["purchaceorder"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped></style>
